import { useSessionStore } from "../../Stores/Session";
import { GenericHttpClient } from "./config/http.generic.client";

/**
 * Delivers frontend tool execution results (Gleap.registerAgentTool handlers
 * running in the host app) back to the awaiting AI agent.
 */
export class HttpFrontendToolService extends GenericHttpClient<any> {
  static _instance: HttpFrontendToolService;
  static getInstance(): HttpFrontendToolService {
    if (this._instance == null) {
      this._instance = new HttpFrontendToolService("/v3/frontend-tools");
    }
    return this._instance;
  }

  protected injectToken(
    headers: Record<string, string | boolean>,
  ): Record<string, string | boolean> {
    const { session, sdkKey } = useSessionStore.getState();

    if (sdkKey) {
      headers["api-token"] = sdkKey;
    }
    if (session && session.gleapId) {
      headers["gleap-id"] = session.gleapId;
    }
    if (session && session.gleapHash) {
      headers["gleap-hash"] = session.gleapHash;
    }

    return headers;
  }

  async deliverResult(args: {
    toolCallId: string;
    result?: any;
    error?: string;
  }): Promise<any> {
    const response = await this.post<any>(`${this.path}/result`, args);
    return response.data;
  }
}
